module.exports = __webpack_public_path__ + "media/RMR Quick Tip Uploading Documentation 5.c45df053.mp4";